import { draftDiscount } from "@redotech/redo-model/discount/discount-db-parser";
import * as z from "zod";
import { redoDiscountSchema } from "./discount-schemas";

export const createDiscount = {
  name: "createDiscount" as const,
  input: z.object({ discountConfiguration: draftDiscount }),
  output: redoDiscountSchema,
};
